import React, { useEffect } from 'react'
import useData from '../hooks/useData'
import { useSiteContext } from './SiteList'
import { isAfter, parseISO } from 'date-fns'
import Icon from './Icon'

const SiteStatus = (props) => {
    const { site } = props
    const version = useData({ url: `https://${site.url}/version.json` })
    const { site_version_array, setSiteVersionArray, latestVersion } = useSiteContext()

    useEffect(() => {
        version?.data && setSiteVersionArray((p) => [...p.filter((o) => o.site_id !== site.id), { site_id: site.id, version: version?.data }])
    }, [version?.data])

    const shouldRebuild =
        site?.latest_article_updated_at &&
        version.data?.BUILD_TIMESTAMP &&
        isAfter(parseISO(site?.latest_article_updated_at), parseISO(version.data?.BUILD_TIMESTAMP))

    const notLatestCommit = latestVersion && version.data?.VERSION !== latestVersion.version?.VERSION

    return (
        <span className="d-block">
            {shouldRebuild ? (
                <>
                    <Icon name="warning" className="text-warning mr-2" />
                    Some updates are not live: {site?.latest_article_updated_at}, {version.data?.BUILD_TIMESTAMP}
                </>
            ) : (
                ''
            )}
            {/* {version.data?.VERSION_TIMESTAMP} - {site?.latest_article_updated_at} */}
            {notLatestCommit ? (
                <>
                    <Icon name="warning" className="text-warning mr-2" />
                    Not the latest engine
                </>
            ) : (
                ''
            )}
        </span>
    )
}

export default SiteStatus
